export const isUserSenderAndReceiver = (userId, mail) => {
  const { receiverId, senderId } = mail

  return userId === senderId && userId === receiverId
}
